import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { FormattedCurrency } from '../../../iwIntlProvider/FormattedCurrency';
import { CLOSE_MODAL } from '../../../iwModals/Modals.actions';
import { Prompt } from '../../ui/prompt';
import styles from './ManualPaymentModal.module.css';
import messages from './ManualPaymentModal.messages';
import DashboardLink from '../../navigation/DashboardLink';
import { Dispatch } from 'redux';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = ({ manualPaymentModal }: RootState) =>
    manualPaymentModal;

const mapDispatchToProps = (dispatch: Dispatch) => ({
    cancel: () => dispatch({ type: CLOSE_MODAL })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const ManualPaymentModal = ({
    amount,
    iban,
    accountNumber,
    sortCode,
    name,
    reference,
    cancel
}: PropsFromRedux) => {
    const formattedManualPaymentAmount = <FormattedCurrency value={amount} />;

    return (
        <div className={styles.BankTransferModal}>
            <div className={styles.title}>
                <FormattedMessage {...messages.title} />
            </div>

            <div className={styles.subTitle}>
                <FormattedMessage
                    {...messages.subTitle}
                    values={{
                        amount: formattedManualPaymentAmount
                    }}
                />
            </div>

            <div className={styles.warningMessage}>
                <FormattedMessage {...messages.warningMessage} />
            </div>

            <div className={styles.content}>
                <table>
                    <tbody>
                        {iban ? (
                            <>
                                <tr>
                                    <td>
                                        <FormattedMessage {...messages.iban} />
                                    </td>
                                    <td>{iban}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            {...messages.referenceName}
                                        />
                                    </td>
                                    <td>{reference}</td>
                                </tr>
                            </>
                        ) : (
                            <>
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            {...messages.accountNumber}
                                        />
                                    </td>
                                    <td>{accountNumber}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            {...messages.sortCode}
                                        />
                                    </td>
                                    <td>{sortCode}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            {...messages.referenceName}
                                        />
                                    </td>
                                    <td>{name}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            {...messages.referenceID}
                                        />
                                    </td>
                                    <td>{reference}</td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
            </div>

            <Prompt className={styles.prompt}>
                <button onClick={cancel}>
                    <FormattedMessage {...messages.cancel} />
                </button>

                <DashboardLink isButton={true}>
                    <FormattedMessage {...messages.sentMoney} />
                </DashboardLink>
            </Prompt>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(ManualPaymentModal);
